<template>
    <div>
        <template v-for="option in collection">
            <slot
                    :option="option"
                    :change="change"
                    :isSelected="isSelected"
            >
                <label :for="'property_type' + option.value" :key="option.value">
                    <input
                            type="checkbox"
                            :id="'property_type' + option.value"
                            name="property_type"
                            @change="change(option.value)"
                    > {{ option.name }}
                </label>
            </slot>
        </template>
    </div>
</template>
<script>
    export default {
        props: {
            options: {
                type: [Array, Object],
                default: () => [],
            },
            dependableIndex: {
                type: String,
                required: false,
            },
            initialSelection: {
                type: [Array],
                default: () => [],
            },
        },
        data() {
            return {
                collection: this.options,
                selected: this.initialSelection,
            };
        },
        created() {
            if (this.dependableIndex) {
                this.collection = this.options[this.dependableIndex];
                this.update();
            }
        },
        methods: {
            isSelected(id) {
                return this.selected.includes(id);
            },
            change(id) {
                if (this.isSelected(id)) {
                    this.selected = this.selected.filter(value => value !== id);
                } else {
                    this.selected.push(id);
                }
                this.update();
            },
            update() {
                this.$emit('input', this.selected);
            },
            swapOptions() {
                this.collection = this.options[this.dependableIndex];
                this.selected = [];
                this.update();
            },
        },
        watch: {
            dependableIndex() {
                this.swapOptions();
            },
        },
    };
</script>
